export default "__VITE_ASSET__BiHvZ$zR__"